// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"cp-z","badgeLink":"dp-z","category":"ep-z"};